/* unplugin-vue-components disabled */import script from "./add.vue?vue&type=script&setup=true&lang=ts"
export * from "./add.vue?vue&type=script&setup=true&lang=ts"

import "./add.vue?vue&type=style&index=0&id=262df31c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-262df31c"]])

export default __exports__